import { GetStaticProps } from 'next'

import { convertToComponent } from '@ecm/data/Contentful'
import { Snippet } from '@ecm/data/Snippet'
import { runEff } from '@ecm/effect'
import PlainHeader from '@ecm/ui/component/block/PlainHeader'
import MainContainer from '@ecm/ui/element/MainContainer'
import DefaultLayout from '@ecm/ui/layout/Default'

type PrivacyPageProps = {
  policy: Snippet
}

const PrivacyPage = ({ policy }: PrivacyPageProps) => (
  <DefaultLayout hideLinks hideFooter hideFinalCta seoPage="privacy">
    <PlainHeader title="Privacy Policy" />

    <MainContainer sx={{ paddingY: '4em' }}>
      {policy && convertToComponent(policy.content, 'p3')}
    </MainContainer>
  </DefaultLayout>
)

export default PrivacyPage

export const getStaticProps: GetStaticProps = async () => {
  const policy = await runEff(eff => eff.getSnippet('privacy-policy'))

  return { props: { policy } }
}
